import OliverText, { TextType } from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";
import "./style.scss";

const Info = () => {
    const { t } = useTranslation();

    return (
        <div className="custom-info-wrapper">
            <div className="editable-info">
                <div className="info-header-with-icon">
                    <img src="/info-payment.svg" alt="" className="info-icon" />
                    <OliverText text={t("editableInfo.paidExtensionHeader")} type={TextType.BUTTON_3} />
                </div>
                <OliverText text={t("editableInfo.paidExtensionBody")} type={TextType.BODY_4} />
            </div>
        </div>
    );
};

export default Info;
